import { httpClient } from './http-client';

export interface BuscarGlobalItemDto {
  id: string;
  tipo: 'comprobante' | 'cliente' | 'producto';
  titulo: string;
  subtitulo: string | null;
  meta: string | null;
  monto: number | null;
  moneda: string | null;
}

export const buscarGlobalService = {
  async buscar(busqueda: string, limite = 5): Promise<BuscarGlobalItemDto[]> {
    const response = await httpClient.get<BuscarGlobalItemDto[]>('/buscar-global', {
      busqueda,
      limite,
    });
    return response.data ?? [];
  },
};
